import { YOO_FINDS_OAUTHCALLBACK } from "@/common";
export const getUriQuery = (
  str: string,
  fields?: string[]
): Record<string, any> => {
  const query: Record<string, any> = {};
  const searchParams = new URLSearchParams(str);
  searchParams.forEach((value, key) => {
    if (value !== undefined) {
      if (fields?.length) {
        if (fields.includes(key)) {
          query[key] = value;
        }
      } else {
        query[key] = value;
      }
    }
  });

  return query;
};

export const compactUriQuery = (query: Record<string, any>) => {
  const newQuery: Record<string, any> = {};
  Object.keys(query).forEach((key) => {
    if (query[key] !== undefined) {
      newQuery[key] = query[key];
    }
  });
  return newQuery;
};

export const getUri = (url: string, query: Record<string, any>) => {
  const searchParams = new URLSearchParams(query);
  let search = "";
  searchParams.forEach((value, key) => {
    search = `${search ? `${search}&` : ""}${key}=${value}`;
  });
  return `${url}${search ? `?${search}` : ""}`;
};

export const getOauthCallbackUrl = (url: string): string => {
  return `${YOO_FINDS_OAUTHCALLBACK}?redirect_uri=${encodeURIComponent(url)}`;
};

export const encodedCallbackUrl = (callbackUrl: string) =>
  encodeURIComponent(callbackUrl);

export const decodedCallback = (encodedCallback: string) =>
  decodeURIComponent(encodedCallback);

export function base64Encode(str: string) {
  return window.btoa(unescape(encodeURIComponent(str)));
}
export function base64Decode(encodedStr: string) {
  return decodeURIComponent(escape(window.atob(encodedStr)));
}
